















import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import getNotificationItem from "../NotificationItem/integrations";

export default defineComponent({
  name: "PageNotificationsView",
  components: { InfiniteScroll, BasePage, PageTitle, EmptyContent },
  props: {
    loading: { type: Boolean, required: true },
    scroll: { type: Boolean, required: true },
    notificationsList: { type: Array as () => Notification[], required: true },
  },
  computed: {
    emptyNotifications(): boolean {
      return !this.loading && this.notificationsList.length === 0;
    },
  },
  methods: {
    getComponent(notification: Notification) {
      return getNotificationItem(notification);
    },
  },
});
